import { render, staticRenderFns } from "./UserIcon.vue?vue&type=template&id=d8565e22"
import script from "./UserIcon.vue?vue&type=script&lang=ts"
export * from "./UserIcon.vue?vue&type=script&lang=ts"
import style0 from "./UserIcon.vue?vue&type=style&index=0&id=d8565e22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports